import { configureStore, IAppState as AppState } from '@mafc/common'
import { Store } from 'redux'
import { isServer } from '../utils'

export const getStore = (
  initialState: AppState = {},
  reducers = {}
): Store<AppState> => {
  return configureStore(initialState, reducers)
}

const __REDUX_STORE__: string = '__REDUX_STORE__'

export const getOrCreateStore = (
  initialState: AppState = {},
  reducers = {},
  context: any
) => {
  if (!context) {
    return getStore(initialState, reducers)
  }
  if (isServer()) {
    const c = context as any
    let req: any
    if (c.req) req = c.req
    if (c.ctx && c.ctx.req) req = c.ctx.req
    if (req) {
      // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
      if (!req.__reduxStore) req.__reduxStore = getStore(initialState, reducers)
      return req.__reduxStore
    }
    return getStore(initialState, reducers)
  }
  // Create store if unavailable on the client and set it on the window object
  if (!(__REDUX_STORE__ in window)) {
    // @ts-ignore
    window[__REDUX_STORE__] = getStore(initialState, reducers)
  }
  // @ts-ignore
  return window[__REDUX_STORE__]
}
